import { idOf } from "../trades/tradeUiLogic";
import ROUTES from "../router/routesModel";
import { spotLngLat } from "./safeSpotDistance";

/**
 * Which accepted trades a "Suggest as meeting place" tap may go to.
 *
 * Only `accepted` can arrange a meetup. Guessing among several, or sending
 * someone into a pending trade, is how the CTA would open the wrong chat.
 */
export const acceptedMeetupTrades = (trades) =>
  (Array.isArray(trades) ? trades : []).filter((t) => t.status === "accepted");

export const counterpartOf = (trade, myId) => {
  const me = String(myId || "");
  return idOf(trade?.senderId) === me ? trade?.receiverId : trade?.senderId;
};

export const counterpartLabel = (trade, myId) => {
  const other = counterpartOf(trade, myId);
  if (!other) return "Collector";
  if (typeof other.name === "string" && other.name.trim()) return other.name.trim();
  const n = other.name || {};
  const joined = [n.first, n.last].filter(Boolean).join(" ").trim();
  return joined || "Collector";
};

export const chatHandoffPath = (trade, myId, safeSpotId) => {
  const params = new URLSearchParams({
    userId: idOf(counterpartOf(trade, myId)),
    tradeId: String(trade?._id || ""),
    safeSpotId: String(safeSpotId || ""),
  });
  return `${ROUTES.CHAT}?${params.toString()}`;
};

/** Google Maps search on the venue point — never a trader's position. */
export const mapsSearchUrl = (spot) => {
  const pair = spotLngLat(spot);
  if (!pair) return null;
  const [lng, lat] = pair;
  const query = spot?.address
    ? encodeURIComponent(spot.address)
    : `${lat},${lng}`;
  return `https://www.google.com/maps/search/?api=1&query=${query}`;
};
